module.exports = __webpack_public_path__ + "img/popupAd-day6.c056d685.png";